var _defs, _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThirteen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #cccccb;\n      }\n\n      .cls-2, .cls-3 {\n        fill: #1f2f60;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M684.44,668.18h-255.87c-16.16,0-29.27,13.1-29.27,29.27v332.94l314.41-1.38v-331.56c0-16.16-13.1-29.27-29.27-29.27h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M242.64,1055.09c-16.16,0-29.27-13.1-29.27-29.27v-400.01c0-16.14-13.13-29.27-29.27-29.27s-29.27,13.13-29.27,29.27-13.1,29.27-29.27,29.27-29.27-13.1-29.27-29.27c0-48.42,39.39-87.81,87.81-87.81s87.81,39.39,87.81,87.81v400.01c0,16.16-13.1,29.27-29.27,29.27Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M396.39,467.28l-106.21,101.68c-25.26,24.18-64.79,25.78-89.92,1.45-25.13-24.33-26.63-65.64-1.45-89.92l212.52-204.97c39.58-38.18,249.01-38.58,289.01,0l212.52,204.97c25.17,24.28,23.67,65.59-1.45,89.92-25.13,24.33-64.74,22.82-89.92-1.45-41.98-40.49-62.77-59.78-104.75-100.27,18.64,83.81,16.76,154.61,3.88,242.63-2.11,14.4-14.42,25.11-28.97,25.11h-270.03c-14.57,0-26.96-10.72-28.98-25.14-11.95-85.13-13.1-155.76,3.77-244h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M684.44,668.18h-128v361.52l157.27-.69v-331.56c0-16.16-13.1-29.27-29.27-29.27h0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M912.85,480.5l-212.52-204.97c-19.91-19.21-81.84-28.75-143.89-28.78v489.68h135.2c14.56,0,26.87-10.71,28.97-25.11,12.87-88.02,14.76-158.81-3.88-242.63,41.98,40.49,62.77,59.79,104.75,100.27,25.17,24.28,64.79,25.78,89.92,1.45,25.12-24.33,26.63-65.64,1.45-89.92h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M478.01,955.49c-41.55,0-75.84,32.62-78.55,73.51,1.59,14.67,14.01,26.08,29.1,26.08h128.17v-20.87c0-43.3-35.43-78.72-78.72-78.72h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M635.16,955.49c41.55,0,75.84,32.62,78.55,73.51-1.59,14.66-14.01,26.08-29.1,26.08h-128.17v-20.87c0-43.29,35.43-78.72,78.72-78.72Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M441.66,102.36c-31.36,30.17-50.9,72.54-50.9,119.39,0,91.38,74.35,165.73,165.73,165.73s165.73-74.35,165.73-165.73c0-47.42-20.02-90.25-52.05-120.49-29.7-28.04-198.71-27.59-228.52,1.1h0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M670.18,101.27c-14.8-13.97-64.21-20.87-113.75-20.72v306.94s.04,0,.06,0c91.38,0,165.73-74.35,165.73-165.73,0-47.42-20.02-90.25-52.05-120.49Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M670.18,101.27c-29.7-28.03-69.72-45.24-113.68-45.24s-85.03,17.66-114.84,46.34c7.09,52.82,55.51,93.7,114.19,93.7s107.77-41.44,114.33-94.79h0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M556.5,56.02s-.04,0-.06,0v140.02c58.82-.27,107.2-41.6,113.75-94.78-29.7-28.04-69.72-45.24-113.68-45.24h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThirteen);
export default __webpack_public_path__ + "static/media/thirteen.8b6c51a433c7665cefc8c6b9af3dccfe.svg";
export { ForwardRef as ReactComponent };